import { render, staticRenderFns } from "./Analyze.vue?vue&type=template&id=220f320e&"
import script from "./Analyze.vue?vue&type=script&lang=js&"
export * from "./Analyze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports